export class DistanceCalculator {
    constructor(unit = 'M') {
        this.unit = unit;
        this.radius = {
            'M': 6371009,
            'KM': 6371.009,
            'MI': 3958.761,
            'NM': 3440.070,
            'YD': 6967420,
            'FT': 20902260
        };
        if (!this.radius[unit]) {
            throw new Error('Unidad no soportada.');
        }
    }
    calcDistance({ lon: lon1, lat: lat1 }, { lon: lon2, lat: lat2 }) {
        const r = this.radius[this.unit];
        lat1 *= Math.PI / 180;
        lon1 *= Math.PI / 180;
        lat2 *= Math.PI / 180;
        lon2 *= Math.PI / 180;
        const lonDelta = lon2 - lon1;
        const a = Math.pow(Math.cos(lat2) * Math.sin(lonDelta), 2) + Math.pow(Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lonDelta), 2);
        const b = Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lonDelta);
        const angle = Math.atan2(Math.sqrt(a), b);
        return angle * r;
    }
}
